import { ModuleApp } from '@huaca/ui';
import { config } from './config';
import { NAV_ITEMS } from './nav';
import { Product } from './Product';

/** Module roles offered in org admin — mirrors huaca/src/products/claro/roles.ts. */
const MODULE_ROLES = { claro: ['claro.editor', 'claro.agent'] };

/**
 * The whole flow in front of the product — login, org, plans, seats, error→screen — comes from
 * @huaca/ui via ModuleApp. We supply only `renderProduct`, which client-side-routes between the
 * Dashboard and the Template Builder. (Firm branding is org-wide and lives on the shared org-admin
 * page in @huaca/ui, so nothing product-specific is needed for it here.)
 */
export function App() {
  return (
    <ModuleApp
      productId={config.productId}
      productName={config.productName}
      moduleRoles={MODULE_ROLES}
      navItems={NAV_ITEMS}
      renderProduct={() => <Product />}
    />
  );
}
